"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonCarousel = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const BronsonCarousel = (props) => {
    return (React.createElement(bronson_react_1.Carousel, { "data-component": 'dh-bronson-carousel' }, props.content.map((element, index) => {
        return (React.createElement("div", { key: index, className: 'c-carousel__item' }, element));
    })));
};
exports.BronsonCarousel = BronsonCarousel;
